module.exports = __webpack_public_path__ + "img/CreateOrJoin1.549148e0.png";